/** @format */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { HmfAlertBannerComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-attributes-components-base-attribute-label',
	standalone: true,
	imports: [HomefieldIconLibraryModule, HmfAlertBannerComponent],
	templateUrl: './base-attribute-label.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseAttributeLabelComponent {
	attributeGroupName = input<string>();
	selectedAttributeValue = input<string>();
	// Whether the selected attribute should be shown if it's been input.
	selectedAttributeValueDisplayable = input<boolean>(true);
	errorMessage = input<string>();
	// Whether the error message should be shown if it's been input.
	errorMessageDisplayable = input<boolean>(true);
}
